<template>
  <div class="message">
    <div id="message-modal" class="modal fade" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body p-5 position-relative">
            <div class="row">
              <div class="col-12">商品</div>
              <div class="col-12 mt-3" v-if="product">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0">
                    <div class="modal-img" :style="util.getImageStyle(product.goodsImg)"></div>
                  </div>
                  <div class="flex-grow-1 ms-3">
                    <div class="modal-brand">{{ getBrandName(product.brandId) }}</div>
                    <div class="modal-name">{{ product.goodsName }}</div>
                  </div>
                </div>
              </div>
              <!--div class="col-12 mt-3 mb-3">
                <label for="message-subject">主旨</label>
                <input id="message-subject" type="text" class="form-control mt-2" disabled :value="consultParent ? consultParent.title : null">
              </div-->
              <div class="col-12 mt-3" v-for="(consult, index) in consultGroup" :key="`msg-${index}`">
                <ul class="list-group">
                  <li class="list-group-item border-gray">
                    <div class="row">
                      <div class="col-auto">您的訊息</div>
                      <div class="col">{{ consult.textContent }}<small class="text-secondary"> - {{ util.getDateTimeStr(consult.questTime) }}</small></div>
                    </div>
                  </li>
                  <li class="list-group-item border-gray">
                    <div class="row">
                      <div class="col-auto">客服回應</div>
                      <div class="col" v-if="consult.replyContent">{{ consult.replyContent }}<small class="text-secondary"> - {{ util.getDateTimeStr(consult.replyTime) }}</small></div>
                      <div class="col text-secondary" v-else>客服尚未回應，請耐心等候。</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 mt-5">
                <button class="btn btn-dark w-100" data-bs-dismiss="modal" :disabled="!isAllReplied" @click="onConsultClicked">繼續詢問</button>
              </div>
            </div>
            <button type="button" class="btn p-5 btn-close position-absolute" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constant from '@/constant.js'
import util from '@/util.js'
import productApi from '@/api/product.js'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MessageModal',
  props: {
    consultGroup: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      product: null
    }
  },
  computed: {
    ...mapGetters([
      'authId',
      'getBrandName'
    ]),
    util: function () {
      return util
    },
    consultParent: function () {
      var ret = null
      if (this.consultGroup) {
        ret = this.consultGroup.find(e => e.parentId === 0)
      }
      return ret
    },
    isAllReplied: function () {
      var ret = false
      if (this.consultGroup) {
        ret = this.consultGroup.every(e => e.replyContent !== null && e.replyContent.length > 0)
      }
      return ret
    }
  },
  watch: {
    consultParent: function (value) {
      if (value) {
        this.apiGetProduct(value.goodsId)
      }
    }
  },
  mounted: function () {
    if (this.consultParent) {
      this.apiGetProduct(this.consultParent.goodsId)
    }
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetProduct: function (id) {
      if (!id) {
        return
      }
      var self = this
      productApi.getProduct(id, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        self.product = rspData
      })
    },
    onConsultClicked: function () {
      if (!this.isAllReplied) {
        return
      }
      var modal = new bootstrap.Modal(document.getElementById('consult-modal'))
      if (modal) {
        modal.show()
      }
    }
  }
}
</script>

<style scoped>
.modal-img {
  width: 84px;
  height: 84px;
}
.modal-brand {
  font-family: 'Noto Serif TC', serif;
  font-size: 1.1rem;
}
.modal-name {
  font-size: 1rem;
}
.btn-close {
  top: 0;
  right: 0;
  z-index: 1;
}
.border-gray {
  border-color: #ededed;
}
</style>
